
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'


//app/views Import
import Login from '../ui/pages/login/view'
import Register from '../ui/pages/register/view'
import ForgotPassword from '../ui/pages/forgotPassword/view' // Import the new component
import Landing from '../ui/pages/landing/view';
import RedirectQrInvoice from '../ui/organisms/qRedirectr/view';
import { Admin } from './admin'


export class Incognit extends Admin {
    getRoutes() {
        return (
            <Router>
                <Routes>
                    {/* <Route path="/redirect" element={<RedirectQrInvoice/>} />
                    { /* <Route path="/register" element={<Register />} /> */}
                    <Route path="/" element={<Login />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} /> {/* New route */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<Login />} />
                    <Route path="*" element={<Login />} />
                </Routes>
            </Router>
        )
    }

}
